var map = {
	"./digital-marketing.jpg": 8481,
	"./jpg/digital-marketing (Large).jpg": 3933,
	"./jpg/digital-marketing.jpg": 6272,
	"./jpg/publications-design (Large).jpg": 8452,
	"./jpg/publications-design.jpg": 1631,
	"./jpg/respnsive-design (Large).jpg": 6403,
	"./jpg/respnsive-design.jpg": 3517,
	"./jpg/web-design (Large).jpg": 145,
	"./jpg/web-design.jpg": 5699,
	"./other/1.jpg": 5199,
	"./other/2.jpg": 3319,
	"./other/web-design-2.jpg": 7769,
	"./publications-design.jpg": 6629,
	"./respnsive-design.jpg": 2912,
	"./web-design.jpg": 4885
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7526;